export const Operators = {
  logicalAND: "Logical.AND",
  logicalOR: "Logical.OR",
  logicalNOT: "Logical.NOT",
  comparisonEQ: "Comparison.EQ",
  comparisonSPECIAL_EQ: "Comparison.SPECIAL_EQ",
  comparisonREGEX_MATCH: "Comparison.REGEX_MATCH",
  comparisonARRAY_CONTAINS: "Comparison.ARRAY_CONTAINS",
  comparisonSTRING_IN: "Comparison.STRING_IN",
  noConditionNull: "No-condition.NULL",
};
